import { render, staticRenderFns } from "./DataSheetEditFormTab.vue?vue&type=template&id=74994865"
import script from "./DataSheetEditFormTab.vue?vue&type=script&lang=js"
export * from "./DataSheetEditFormTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports